export const getTheme = (state) => state.theme;



// WEBPACK FOOTER //
// ./src/reducers/theme/selectors.js